import React from 'react'

import "./HomeSection5.css"

import Hs5 from "../../../../assets/imgs/hs5.png"
import Hs6_1 from "../../../../assets/imgs/Hs6_1.png"
import Hs6_2 from "../../../../assets/imgs/Hs6_2.png"
import Hs6_3 from "../../../../assets/imgs/Hs6_3.png"



function HomeSection5() {
  return (
    <>
    <div className='hs1'>
    <span className='hs1-head'>WE CERTIFIED</span>
   <span className='hs1-title'>Our Certificates</span>
   <img id='hs5Img' src={Hs5} alt="" />
   </div>
   <div className='hs5'>
    <img src={Hs6_1} alt="" />
    <img src={Hs6_2} alt="" />
    <img src={Hs6_3} alt="" />

   </div>
    </>
  )
}

export default HomeSection5
